<template>
	<v-card>
		<app-schedule-tour-title @close="$emit('close')" />

		<v-card-text class="text-xs-center">
			<img v-wh="128" src="/img/form-success.png" class="my-4">
			<h2 class="mb-4">Thank you!</h2>
			<p>
				A confirmation email has been sent to the email address provided.
				If you do not receive an email confirming your appointment, please contact us.
			</p>
		</v-card-text>

		<v-card-actions class="px-5 pb-3">
			<v-btn color="blue" dark class="mx-auto" @click="$emit('close')">Close</v-btn>
		</v-card-actions>
	</v-card>
</template>

<script>
export default {
	components: {
		AppScheduleTourTitle: () => import('@/components/schedule-tour/Title.vue'),
	},
}
</script>
